import {IEvent} from 'modules/wineshops-list/models';
import {memo} from 'react';
import Link from 'components/Link';
import style from './style.module.scss';
import Picture from 'components/Picture';
import {Typography} from 'components/Typography';
import {DATE_TEMPLATES, formatDate} from 'core/helpers/dates';
import {formatPrice} from 'core/helpers';
import {useEventsRoutes} from 'core/modules/routing/hooks/useEventsRoutes';
import {PRICE_STYLE} from 'core/constants';
import {getMediaSrc} from 'core/helpers/media';

export const EventCard = memo<IEvent>(function EventCard({
    id,
    title,
    eventDate,
    price,
    previewImage,
    eventTimeBegin,
    eventTimeEnd,
    address,
}) {
    const {url} = useEventsRoutes();

    return (
        <Link
            className={style.event}
            href={url({
                id,
            })}
        >
            <div className={style.image}>
                <Picture
                    sources={{}}
                    src={getMediaSrc(previewImage?.url || '', {isWebp: true, width: 320})}
                    alt={`Мероприятие - ${title}`}
                />
            </div>
            <div className={style.body}>
                <Typography className={style.date} variant={'ch-title-18-b'}>
                    {formatDate(eventDate, DATE_TEMPLATES.D_MMMM)}
                </Typography>
                <div className={style.title}>{title}</div>
                <Typography color={'gray100'} variant={'body-16-r'}>
                    {address}
                </Typography>
                <div>
                    <Typography color={'gray100'} variant={'body-16-r'}>
                        {eventTimeBegin}
                    </Typography>
                    {eventTimeEnd && (
                        <Typography color={'gray100'} variant={'body-16-r'}>
                            {' '}
                            - {eventTimeEnd}
                        </Typography>
                    )}
                </div>
                <Typography className={style.price} color={'gray100'} variant={'label-16-m'}>
                    {formatPrice(price.toString(), {style: PRICE_STYLE.currency})}
                </Typography>
            </div>
        </Link>
    );
});
